import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const ProductLoader = (props: IContentLoaderProps) => {
    return (
        <ContentLoader
            speed={1}
            width="100%"
            height="100%"
            backgroundColor="#f5f5f5"
            foregroundColor="#dbdbdb"
            {...props}
        >
            <rect x="0" y="0" rx="0" ry="0" width="150" height="150" />
            <rect x="166" y="37" rx="0" ry="0" width="62" height="10" />
            <rect x="166" y="57" rx="0" ry="0" width="124" height="10" />
            <rect x="166" y="78" rx="0" ry="0" width="82" height="10" />
            <rect x="166" y="95" rx="0" ry="0" width="60" height="10" />
        </ContentLoader>
    );
};
